import uniqueId from "../../utils/uniqueId";

export default (v2Relationship, subjectId, newReferenceIdForV2Id) => {
  const rId = uniqueId();
  const referenceId = newReferenceIdForV2Id[v2Relationship.role];
  return {
    id: rId,
    subject: subjectId,
    reference: referenceId,
    object: v2Relationship.entity
  };
};
